import {PrevSvg} from "@/app/components/icons/PrevSvg";
import {NextSvg} from "@/app/components/icons/NextSvg";
import styles from "./app-slider.module.css";
import {cn} from "@/lib/utils";

interface IProps {
    className?: string;
    onPrev: () => void;
    onNext: () => void;
    prevDisabled?: boolean;
    nextDisabled?: boolean;
}

export const AppSlider = ({className, onPrev, onNext, prevDisabled, nextDisabled}: IProps) => {
    return (
        <div
            className={cn("rounded-[8px] bg-gray inline-flex items-center justify-center w-[64px] h-[32px]", styles.Slider, className)}>
            <button disabled={prevDisabled} onClick={() => onPrev()}
                    className={cn('flex items-center justify-center w-[50%] h-full', {['cursor-pointer']: !prevDisabled}, {['cursor-not-allowed']: prevDisabled})}>
                <PrevSvg/>
            </button>
            <div className={styles.Separator}/>
            <button disabled={nextDisabled} onClick={() => onNext()}
                    className={cn('flex items-center justify-center w-[50%] h-full', {['cursor-pointer']: !nextDisabled}, {['cursor-not-allowed']: nextDisabled})}>
                <NextSvg/>
            </button>
        </div>
    )
}
